<template>
  <el-card class="file-table-container">
    <el-form :model="findForm" ref="findForm" label-width="100px" class="find-form" :inline="true">
      <el-form-item label="文件来源" prop="origin">
        <el-select v-model="findForm.origin" placeholder="请选择文件来源">
          <el-option label="openApi" value="openApi"></el-option>
          <el-option label="XPS系统" value="xpsSystem"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="文件名称" prop="name">
        <el-input v-model="findForm.name" class="form-input" placeholder="请输入文件名称" @keydown.enter.native="findDateFile('findForm')"></el-input>
      </el-form-item>
      <el-form-item label="上传人员" prop="user">
        <el-select v-model="findForm.userId" placeholder="请选择上传人员" clearable filterable remote :remote-method="getUserList" :loading="loading">
          <el-option v-for="item in userInfo" :key="item.userId" :label="item.fullName" :value="item.userId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="CDN地址" prop="cdn">
        <el-input v-model="findForm.cdn" class="form-input" placeholder="请输入CDN地址" @keydown.enter.native="findDateFile('findForm')"></el-input>
      </el-form-item>

      <el-form-item align="center">
        <el-button type="primary" @click="findDateFile('findForm')">搜索</el-button>
        <el-button @click="resetForm('findForm')">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" style="width: 100%" :max-height="height" :highlight-current-row="true">
      <div slot="empty" class="empty-content empty-image">
        <p class="empty-text">暂无数据哦~</p>
      </div>
      <el-table-column label="文件名称" prop="fileName" show-overflow-tooltip min-width="200px">
        <template v-slot="{row}">
          <div class="file-content file-page-container">
            <img v-if="row.isImg&&!row.isReject" class="file-image" :src="row.url" fit="contain" />
            <div v-if="!row.isImg&&!row.isReject" class="file-image file-icon" :class="`file-icon-${row.ext}`"> </div>
            <img v-if="row.isReject" class="file-image" src="https://front-xps-cdn.xsyx.xyz/custom/xps/images/delete.png" fit="contain" title="文件已删除" />
            <span class="file-name">{{row.fileName}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="上传人员" prop="userName" align="center" min-width="120px">
      </el-table-column>
      <el-table-column label="CDN地址" prop="url" show-overflow-tooltip min-width="400px">
        <template v-slot="{row}">
          <span class="table-cdn" v-clipboard:copy="row.url" v-clipboard:success="onCopy">{{row.url}}</span>
        </template>
      </el-table-column>
      <el-table-column label="文件来源" prop="source" align="center">
      </el-table-column>
      <el-table-column label="上传时间" prop="createTime" width="150px">
        <template v-slot="{row}">
          {{row.createTime?formatTime(row.createTime):''}}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" min-width="130px">
        <template v-slot="{row}">
          <el-button type="text" :disabled="!row.canGo||row.isReject" @click="openFileDirection(row)" :title="row.isReject?'文件已删除':''">打开文件位置</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination class="table-container-pager" @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="pageConfig.pageNum" :page-sizes="[ 50, 100, 200,500]" :page-size="pageConfig.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" :pager-count="5">
    </el-pagination>
  </el-card>
</template>

<script>
import { getExt, isImg } from '@/common/utils/ext.js';
import { fileManageApi, userApi } from '@/api/index';
import { showLoading, hideLoading } from '@/plugins/loading';
import dayjs from 'dayjs';
export default {
  props: {
    date: {
      type: String,
      default: ''
    },
    userId: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      findForm: {
        origin: 'xpsSystem',
        name: '',
        userId: '',
        cdn: ''
      },
      tableData: [],
      pageConfig: {
        pageNum: 1,
        pageSize: 50
      },
      findFileList: [],
      isFind: false,
      search: '',
      total: 0,
      loading: false,
      userInfo: [],
      height: '100%'
    }
  },
  mounted () {
    this.findForm.userId = this.userId || '';
    this.getUserList();
    this.findDateFile('findForm');
    this.height = `${document.documentElement.clientHeight - 300}px`;
    this.onWindowResize();

  },
  methods: {
    findDateFile (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.isFind = true;
          showLoading();
          const res = await fileManageApi.findDateFile({ ...this.findForm, ...this.pageConfig, date: this.date });
          if (res.code === 200) {
            if (res.data.length > 0) {
              res.data.forEach(item => {
                item.isImg = isImg(item.url);
                item.ext = getExt(item.url);
                item.canGo = item.url.indexOf('https://front-xps-cdn.xsyx.xyz/custom/') !== -1 || item.url.indexOf('https://uat-xps-cdn.xsyx.xyz/custom/') !== -1;
              })

            }
            this.tableData = res.data;
            this.total = res.total;
          } else {
            this.$message.error(res.message);
          }
          hideLoading();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm (formName) {
      this.isFind = false;
      this.$refs[formName].resetFields();
    },
    openFileDirection (row) {
      let fPathArr = row.url.split('https://front-xps-cdn.xsyx.xyz');
      if (fPathArr.length <= 1) {
        fPathArr = row.url.split('https://uat-xps-cdn.xsyx.xyz')
      }
      const fPath = fPathArr[1];
      const path = fPath.substr(0, fPath.lastIndexOf('/') + 1);
      const name = fPath.substr(fPath.lastIndexOf('/') + 1);
      this.$router.push({ name: 'projectDetail', query: { path, name } })
    },
    // 复制
    onCopy () {
      this.$message.success('文件地址复制成功', 2);
    },
    // 格式化时间
    formatTime (time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },
    // 当当前页数改变，触发事件
    handlePageChange (num) {
      this.pageConfig.pageNum = num;
      this.findDateFile('findForm');
    },
    // 当页面显示数据总数改变，触发事件
    handleSizeChange (size) {
      this.pageConfig.pageSize = size;
      this.findDateFile('findForm');
    },
    // 获取用户列表
    getUserList (realName = '') {
      this.loading = true;
      setTimeout(async () => {
        this.loading = false
        const res = await userApi.getUserList({ realName })
        this.userInfo = res.userInfo
      }, 200);
    },
    // 搜索规则下拉框change事件
    handleChange (val) {
      this.$refs["findForm"].resetFields(); // 重置表单校验
      this.findForm.rule = val; // 再次赋值
    },
    // 监听窗口变化
    onWindowResize () {
      window.addEventListener('resize', () => {
        this.$nextTick(() => {
          this.height = `${document.documentElement.clientHeight - 300}px`
        })
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.file-table-container {
  .form-input {
    width: 400px;
  }
  .find-file-container {
    position: relative;
    height: 500px;
    .empty-content.empty-image {
      height: 400px;
      background-size: 60%;
      background-image: url("https://front-xps-cdn.xsyx.xyz/custom/xps/images/upload.png");
    }
    .empty-text.other-text {
      position: relative;
      top: 40px;
    }
    .find-container-pager {
      margin-top: 10px;
      text-align: center;
    }
  }
  .file-content {
    display: flex;
    justify-content: left;
    align-items: center;
    .file-image {
      display: inline-block;
      margin-right: 20px;
      width: 40px;
      max-height: 40px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      &.file-icon {
        height: 40px;
      }
    }
  }
  .table-cdn {
    cursor: pointer;
    &:hover {
      color: #409eff;
    }
  }
  .table-container-pager {
    margin-top: 15px;
    text-align: right;
  }
}
</style>